import { createAppRequest } from '@/services/request';
import type { ApiRequestOptions } from './types/common';
import type {
  FamsPortfolioOverviewItem,
  FamsPortfolioOverviewListResponse,
  FamsPortfolioOverviewOptionsResponse,
  FamsPortfolioOverviewQueryParams,
} from './types/portfolio-overview';

const request = createAppRequest();

export async function getFamsPortfolioOverviewOptions(
  params?: FamsPortfolioOverviewQueryParams,
  options?: ApiRequestOptions,
) {
  return request<FamsPortfolioOverviewOptionsResponse>('/bff/fams/portfolio-overview/options', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

export async function getFamsPortfolioOverviewList(
  params?: FamsPortfolioOverviewQueryParams,
  options?: ApiRequestOptions,
) {
  return request<FamsPortfolioOverviewListResponse>('/bff/fams/portfolio-overview/list', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

export async function getFamsPortfolioOverviewDetail(
  id: string,
  params?: Pick<FamsPortfolioOverviewQueryParams, 'snapshotDate' | 'viewMode'>,
  options?: ApiRequestOptions,
) {
  return request<FamsPortfolioOverviewItem>(`/bff/fams/portfolio-overview/${id}`, {
    method: 'GET',
    params,
    ...(options || {}),
  });
}
